exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formula-display{padding:.1rem 0;word-break:break-word}.formula-display.formula-display--toggle{cursor:default}.formula-display.formula-display--nowrap{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.formula-display .information-icon{vertical-align:middle;color:var(--fts-gray-400)}.formula-display .variable{color:var(--fts-formula-ref,#b26a00);font-weight:600}.formula-display .path-indicator{color:var(--fts-gray-400)}", ""]);

// exports
